<template>
  <!-- 主區域底層模板 -->
  <section class="drawer-layout Jost">
    <!-- 左邊 -->
    <section class="drawer-layout__left">
      <div class="drawer-layout__left-scroll">
        <div class="drawer-layout__left-header">
          <el-row>
            <el-col :span="5">預約時間：</el-col>
            <el-col :span="19" style="color:#000000"> {{ bookingStayRange || '-' }} </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">服務地點：</el-col>
            <el-col :span="19" style="color:#000000">{{ currentProduct.title }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="5">已選房型：</el-col>
            <el-col :span="19" style="color:#000000">
              {{ bookingRoomTitles }}
            </el-col>
          </el-row>
        </div>
        <div class="drawer-layout__left-content">
          <MemberSearch @next-step="forwardStep" @open-member-create="openCustomerCreate" />
        </div>
      </div>
    </section>
    <!-- 右邊 -->
    <section class="drawer-layout__right">
      <div class="drawer-layout__right-scroll">
        <OriginalOrderListPartial :roomList="detailedBookingList" :calculateOrder="calculateOrder" />
      </div>
      <CustomerCreatePartial :show.sync="isShowCustomerCreate" :editData="currentMember" @save="handleCustomerCreateSave" @close="isShowCustomerCreate = false" />
    </section>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

import MemberSearch from './partials/MemberSearchPartial.vue'
import OriginalOrderListPartial from './partials/OriginalOrderListPartial.vue'
import CustomerCreatePartial from './partials/CustomerCreatePartial.vue'
import { formatHotelStayRange } from '@utils/format-hotel-stay'
import API from '../../api'

export default {
  name: 'Step1hotelBooking',
  components: {
    MemberSearch,
    OriginalOrderListPartial,
    CustomerCreatePartial,
  },
  props: {},
  data() {
    return {
      isShowCustomerCreate: false,
      currentMember: null,
    }
  },
  watch: {
    selectedBookingRoomsList: {
      handler(newList) {
        if (this.currentProduct?.id && newList?.length > 0) {
          this.fetchPostHotelOrderCalculate()
        }
      },
      immediate: true,
      deep: true,
    },
    totalAmount: {
      handler(newVal) {
        if (newVal !== undefined) {
          this.$emit('update-total', newVal)
        }
      },
      immediate: true,
    },
  },
  computed: {
    bookingStayRange() {
      return formatHotelStayRange({
        bookings: this.selectedBookingRoomsList,
        showCheckoutDate: this.showCheckoutDate,
      })
    },
    bookingRoomTitles() {
      if (!this.selectedBookingRoomsList?.length) return ''
      const titles = this.selectedBookingRoomsList.map((item) => item.room?.roomTitle)
      // 去除重複的名稱 (避免同一房型訂多天時重複顯示) 並過濾掉空值
      const uniqueTitles = [...new Set(titles)].filter((title) => title)
      return uniqueTitles.join(' & ')
    },
    totalAmount() {
      const totalRoomPrice = this.detailedBookingList.reduce((sum, item) => sum + (Number(item.price) || 0), 0)
      const totalAdjustPrice = this.calculateOrder?.priceRuleAdjustment?.reduce((sum, item) => {
        return sum + (Number(item.price) || 0)
      }, 0)

      return totalRoomPrice + totalAdjustPrice
    },
    ...mapGetters('hotel/order', ['selectedBookingRoomsList', 'detailedBookingList', 'calculateOrder', 'adminBackfillMode']),
    ...mapGetters('hotel/setting', ['currentProduct', 'showCheckoutDate']),
  },
  methods: {
    forwardStep(step) {
      console.log('forwardddd', step)
      this.$emit('next-step', step)
    },
    async fetchPostHotelOrderCalculate() {
      if (!this.currentProduct?.id) return
      try {
        const payload = {
          bookings: this.selectedBookingRoomsList.map((item) => ({
            date: item.date,
            roomTypeId: item.type.id,
            roomId: item.roomId,
            guestCount: 1,
          })),
        }
        if (this.adminBackfillMode) {
          payload.adminBackfill = true
        }
        const calculateOrder = await API.order.postHotelOrderCalculate(this.currentProduct.id, payload)
        this.$store.commit('hotel/order/SET_CALCULATE', calculateOrder)
        console.log('res', calculateOrder)
      } catch (error) {
        console.log(error)
      }
    },
    openCustomerCreate() {
      console.log('open customer create')
      this.isShowCustomerCreate = true
    },
    handleCustomerCreateSave(newMember) {
      this.$store.commit('hotel/order/SET_MEMBER', newMember)
      this.isShowCustomerCreate = false
      this.forwardStep(2)
    },
  },
}
</script>

<style lang="scss" scoped>
.drawer-layout {
  display: flex;
  height: calc(100vh - 60px); // adjust if drawer header changes
  width: 100%;
  position: relative;
  margin: 0 20px 0 50px;

  &__left {
    width: 50%;
    height: 100%;
    overflow: hidden;
    border-right: 2px solid #e6e6e6;
    display: flex;
    flex-direction: column;

    &-scroll {
      flex: 1;
      overflow-y: auto;
      display: flex;
      flex-direction: column;

      &::-webkit-scrollbar {
        width: 8px;
      }

      &::-webkit-scrollbar-track {
        background: #f0f0f0;
        border-radius: 4px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #999;
        border-radius: 4px;
        border: 2px solid #f0f0f0;
      }

      &::-webkit-scrollbar-thumb:hover {
        background-color: #666;
      }
    }

    &-header {
      position: sticky;
      top: 8px;
      padding-top: 18px;
      z-index: 10;
      background-color: #f9f9fb;
      border-bottom: 1px solid #e6e6e6;
      font-size: 18px;
      font-weight: 700;
      line-height: 2.2;
    }

    &-content {
      margin: 20px 20px 0px 0px;
    }
  }

  &__right {
    width: 50%;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    &-scroll {
      flex: 1;
      overflow-y: auto;
      padding: 16px;
      padding-right: 30px;
      font-size: 16px;
      line-height: 1.8;

      &::-webkit-scrollbar {
        width: 8px;
      }

      &::-webkit-scrollbar-track {
        background: #f0f0f0;
        border-radius: 4px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #999;
        border-radius: 4px;
        border: 2px solid #f0f0f0;
      }

      &::-webkit-scrollbar-thumb:hover {
        background-color: #666;
      }
    }
  }
}
</style>
